import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkspaceOption } from '../types';

interface TopbarProps {
  workspaceName: string;
  projectName: string;
  memberships: WorkspaceOption[];
  selectedProjectId: string;
  onProjectChange: (projectId: string) => void;
  rangeDays: number;
  onRangeChange: (days: number) => void;
  onSignOut: () => void;
  userName: string;
  loading?: boolean;
  actionLoading?: boolean;
}

export function Topbar({
  workspaceName,
  projectName,
  memberships,
  selectedProjectId,
  onProjectChange,
  rangeDays,
  onRangeChange,
  onSignOut,
  userName,
  loading = false,
  actionLoading = false,
}: TopbarProps) {
  const navigate = useNavigate();
  const brandLogoSrc = '/founderpulselogo.png';

  return (
    <header className="topbar">
      <div className="topbar__crumbs">
        <div className="brand-mark brand-mark--small">
          <img className="brand-mark__image" src={brandLogoSrc} alt="FounderPulse logo" />
        </div>
        <div>
          <div className="topbar__eyebrow">FounderPulse</div>
          <div className="topbar__title">
            {workspaceName} / {projectName}
          </div>
        </div>
      </div>

      <div className="topbar__controls">
        <label className="topbar-select">
          <span>Workspace</span>
          <select 
            value={selectedProjectId} 
            onChange={(event) => onProjectChange(event.target.value)}
            disabled={loading || memberships.length === 0}
          >
            {loading ? (
              <option value="">Loading projects...</option>
            ) : memberships.length === 0 ? (
              <option value="">No projects found</option>
            ) : (
              <>
                <option value="all">All teams</option>
                {memberships.map((membership) => (
                  <option key={membership.projectId} value={membership.projectId}>
                    {membership.workspaceName} / {membership.projectName}
                  </option>
                ))}
              </>
            )}
          </select>
        </label>

        <label className="topbar-select">
          <span>Date range</span>
          <select value={rangeDays} onChange={(event) => onRangeChange(Number(event.target.value))}>
            <option value={7}>Last 7 days</option>
            <option value={14}>Last 14 days</option>
            <option value={30}>Last 30 days</option>
          </select>
        </label>

        <div className="topbar-user">
          <div 
            className="avatar avatar--topbar" 
            onClick={() => navigate('/dashboard/profile')}
            style={{ cursor: 'pointer' }}
            title="Go to Profile"
          >
            {userName.slice(0, 2).toUpperCase()}
          </div>
          <button type="button" className="button button--ghost button--mono" onClick={onSignOut} disabled={actionLoading}>
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
}
